import { useMembersContext } from '@/contexts/membersContext';
import { Jurisdiction } from '@/types/jurisdiction';
import ajax from '@/utils/ajax';
const jurisdictionRepository = {
  BASE_PATH: '/api/jurisdictions/',

  async list(host: string): Promise<Jurisdiction[]> {
    const response = await ajax.get({
      url: `${host}${this.BASE_PATH}`
    });

    return response.data;
  }
};

export const JurisdictionRepository = () => {
  const { host } = useMembersContext();

  return {
    async list() {
      return jurisdictionRepository.list(host);
    }
  };
};
